import ReportConfigsConverter from 'scripts/application/dto_converters/report_configs_converter';

export default function fetchReportConfigs(context) {
  context.stores.reportConfigs.setLoading();

  return context.gateways.reportConfigs.fetch().then(response => handleSuccess(response));

  function handleSuccess(response) {
    context.stores.reportConfigs.set(ReportConfigsConverter.fromDto(response));
    context.stores.reportConfigs.resetLoading();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/reporting/fetch_report_configs.js